document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".hc_logi_yen").forEach(function (el) {
        let num = parseInt(el.textContent.replace(/,/g, ""), 10);
        if (!isNaN(num)) {
            el.textContent = num.toLocaleString();
        }
    });
});

